import type {
  Journey,
  JourneyRequest,
  JourneyVerifyRequest,
} from '../../../domain/models/journey'
import * as types from '../types/journey-types'

// Get Journey Actions
export const getJourneyRequest = (payload: JourneyVerifyRequest) => ({
  type: types.GET_JOURNEY_REQUEST,
  payload,
})

export const getJourneySuccess = (payload: Journey | null) => ({
  type: types.GET_JOURNEY_SUCCESS,
  payload,
})

export const getJourneyError = (payload: string) => ({
  type: types.GET_JOURNEY_ERROR,
  payload,
})

// Create Journey Actions
export const createJourneyRequest = (payload: JourneyRequest) => ({
  type: types.CREATE_JOURNEY_REQUEST,
  payload,
})

export const createJourneySuccess = (payload: Journey) => ({
  type: types.CREATE_JOURNEY_SUCCESS,
  payload,
})

export const createJourneyError = (payload: string) => ({
  type: types.CREATE_JOURNEY_ERROR,
  payload,
})

// Utility Actions
export const journeyReset = ({ resetAll = true }) => ({
  type: types.JOURNEY_RESET,
  payload: resetAll,
})

export const journeyUpdate = (payload: Partial<JourneyRequest>) => ({
  type: types.JOURNEY_UPDATE,
  payload,
})

// Conclude Journey Actions
export const concludeJourneyRequest = (journeyId: number) => ({
  type: types.CONCLUDE_JOURNEY_REQUEST,
  payload: { journeyId },
})

export const concludeJourneySuccess = () => ({
  type: types.CONCLUDE_JOURNEY_SUCCESS,
})

export const concludeJourneyError = (payload: string) => ({
  type: types.CONCLUDE_JOURNEY_ERROR,
  payload,
})
